<template>
  <div>
    <NavBar :pages="pages" ></NavBar>
    
    <b-container fluid class="mt-4 bg-light-gray h-100">
      <router-view></router-view>
    </b-container>
  </div>
</template>

<script>
  import NavBar from '../components/navbar/NavBar'
  export default {
    name: `AdminPage`,
    data() {
      return {
        pages: [
          {name : `Clients` , href: `/admin/clients`},
          // {name : `Examinees` , href: `/admin/examinees`},
          {name : `Exams` , href: `/admin/exams`},
          // {name : `Settings` , href: `/admin/settings`}
        ]
      }
    },
    components: {
      NavBar,
    },
  }
</script>

<style lang="css" scoped>
body {
  height:100%
}
</style>